import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./style.css";
import { getTokenInfo } from './../../UseToken';
import Hosts, { companycode } from "../../Hosts"
import { reqGET, reqPUT, content_language } from '../../Utils';
//import { Redirect } from 'react-router-dom';
import Notificacoes from '../Main/Notificacoes';

import {
    set_language,
    repo_logo_link,
    repo_icons_link,

} from '../../Utils';

import { language } from '../WEBContent/Language';
import { icon } from '../WEBContent/Icon';
import { color } from '../WEBContent/Color';

function logout() {

    if (localStorage.cart !== undefined && localStorage.cart !== null) {
        let aux = localStorage.cart
        localStorage.clear();
        localStorage.cart = aux
    }
    else {
        localStorage.clear();
    }

    //console.log('CAHCE LIMPA');
    //< Redirect to='/SIMWEBSITE' replace />
    //window.location.href = '/chucb-conference-gest';
}
//<img src="./img/logo-icon.png" alt="Fasquia Importante" className="light-logo-mobile" />
//<img  src="./img/logo.png" alt="Fasquia Importante" className="light-logo " />

const Header = (props) => {

    const { pathname } = useLocation();

    //let id = getTokenInfo().id;
    let username = getTokenInfo().name;
    let profile = getTokenInfo().profile;

    const [lang, set_lang] = useState('pt');
    const [userid, setUserId] = useState(getTokenInfo().id)
    const [colaboradores, setResponsaveis] = useState([])
    const [entities, setEntities] = useState([])
    const [projetos, setProjetos] = useState([])
    const [utilizadorLogado, setUtilizadorLogado] = useState([])
    const [tarefas, setTarefas] = useState([])
    const [tarefasUtilizador, setTarefasUtilizadorLogado] = useState([])
    const [entidade, setEntidadeLogada] = useState([])

    const [dia_hora, set_dia_hora] = useState('')

    const [notifications, set_notifications] = useState([])

    useEffect(() => {

        const fetchData = async () => {
            try {
                // 1. Buscar entidades e dados do utilizador
                const entitiesResponse = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
                //console.log('Entities Data:', entitiesResponse);

                // Obter ID do utilizador do token
                const userId = getTokenInfo().id;

                // Filtrar utilizador logado
                const userData = entitiesResponse.data.find(
                    entity => entity.id === userId
                );

                setUtilizadorLogado(userData)
                console.log("Utilizador logado no header:", utilizadorLogado)

                // 2. Processar entidades
                const internalEntities = entitiesResponse.data
                    .filter(entity => entity.entity_type === "1")
                    .map(entity => ({
                        id: entity.id,
                        nome: entity.name
                    }));

                const externalEntities = entitiesResponse.data
                    .filter(entity => entity.entity_type === "2")
                    .map(entity => ({
                        id: entity.id,
                        nome: entity.name
                    }));

                setResponsaveis(internalEntities);
                setEntities(externalEntities);

                // 3. Buscar projetos
                const projetosResponse = await reqGET(
                    `${Hosts.SIMCore_API}/intranet/projetos/${getTokenInfo().companycode}`
                );


                const projetosFiltrados = projetosResponse.data.filter(projeto => {
                    return new Date(projeto.info.date[0]?.available);
                });
                setProjetos(projetosFiltrados);

                // 4. Buscar e filtrar tarefas
                const tarefasResponse = await reqGET(
                    `${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`
                );


                setTarefas(tarefasResponse.data);
                const entidade = await reqGET(`${Hosts.SIMCore_API}/entities/${getTokenInfo().companycode}/${userid} `);
                console.log("Entidade logada aaaa", entidade.data[0])
                setEntidadeLogada(entidade.data[0])
                const entidadeLogada = entidade?.data?.[0];

                if (entidadeLogada?.info?.notify) {
                    const dataAtual = new Date().toISOString().split('T')[0]; // "2025-02-03"
                    const dataNotificacao = entidadeLogada.info.notify.dataAtual?.split('T')[0]; // "2025-01-31"

                    console.log("Data atual:", dataAtual);
                    console.log("Data da notificação:", dataNotificacao);

                    if (!dataNotificacao || dataNotificacao !== dataAtual) {
                        console.log("Entrou nesta  condição!!! Limpando notify.tarefas...");

                        entidadeLogada.info.notify.tarefas = []; // Limpa o array
                        entidadeLogada.info.notify.dataAtual = new Date().toISOString(); // Atualiza para a data atual completa

                        try {
                            reqPUT(`${Hosts.SIMCore_API}/entities/`, entidadeLogada)
                            console.log("PUT realizado com sucesso!", entidadeLogada);
                        } catch (error) {
                            console.error("Erro ao atualizar entidade:", error);
                        }
                    }
                } else {
                    console.log("⚠️ entidade.info ou entidade.info.notify não existem!");
                    console.log("Debug entidade:", entidade);
                }

                // Filtrar tarefas usando userData local

                //console.log("User ID:", userId);
                // console.log("Entidade info:", entidade.info);
                //console.log("Notify:", entidade.info?.notify);
                // console.log("Tarefas notificadas:", entidade.info?.notify?.tarefas);
                const tarefasUtilizadorLogado = tarefasResponse.data.filter(task => {
                    const dataAtual = new Date().toISOString().split('T')[0]; // Current date in 'YYYY-MM-DD'
                    const taskDataInicio = task.info?.data_inicio?.split('T')[0]; // Extract date part from task

                    return (
                        // Check if user is a responsible
                        task.info?.responsaveis?.some(resp => String(resp.value) === userId) &&
                        // Exclude tasks already in notify.tarefas
                        !entidadeLogada.info?.notify?.tarefas?.includes(task.id) &&
                        // Check if task's start date matches today
                        taskDataInicio === dataAtual
                    );
                });

                setTarefasUtilizadorLogado(tarefasUtilizadorLogado);
                console.log("tarefas utilizador logado para hoje", tarefasUtilizadorLogado)

            } catch (error) {
                console.error("Erro na obtenção de dados:", error);
                // Adicionar tratamento de erro adequado
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            var today_submit = new Date()
            let dia_aux = today_submit.getDate().toString().padStart(2, '0') + '-' + (today_submit.getMonth() + 1).toString().padStart(2, '0') + '-' + today_submit.getFullYear()
            let hora_aux = today_submit.getHours().toString().padStart(2, '0') + ':' + today_submit.getMinutes().toString().padStart(2, '0') + ':' + today_submit.getSeconds().toString().padStart(2, '0')
            set_dia_hora(dia_aux + ' ' + hora_aux)

            // console.log('dia_aux', dia_aux)
            // console.log('hora_aux', hora_aux)
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(async () => {
        // const interval = setInterval(async () => {

        let notifications = await reqGET(`${Hosts.SIMCore_API}/entities/notification/${getTokenInfo().companycode}/${getTokenInfo().id}`);
        if (notifications !== undefined && notifications !== null) {
            //console.log(notifications.data)
            set_notifications(notifications.data)
        }

        // }, 60000);

        // return () => clearInterval(interval);
    }, [pathname]);

    //let office = getTokenInfo().office.name;


    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        console.log("LANG A VER SE MUDA",lang)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)


    }, [])

    const notification_read = async (id_notification) => {

        try {
            let dados_envio = {
                id_entity: getTokenInfo().id,
                companycode: getTokenInfo().companycode,
                id_notification: id_notification
            }
            reqPUT(`${Hosts.SIMCore_API}/entities/notification/read`, dados_envio)

        } catch (error) {
            console.error("Erro ao atualizar entidade:", error);
        }

    }

    const notification_read_all = async () => {

        let aux = [];
        for await (let element of notifications) {
            aux.push(element.id_notification)
        }

        try {
            let dados_envio = {
                id_entity: getTokenInfo().id,
                companycode: getTokenInfo().companycode,
                notifications: aux
            }
            reqPUT(`${Hosts.SIMCore_API}/entities/notification/read/all`, dados_envio)

        } catch (error) {
            console.error("Erro ao atualizar entidade:", error);
        }

        set_notifications([]); // Limpa as notificações após marcar como lidas
    }

    const statusIcons = {
        // Status icons mapping
        // Iniciar
        'A Iniciar': {
            className: icon.iniciar.className,
            style: icon.iniciar.style
        },
        'To Start': {
            className: icon.iniciar.className,
            style: icon.iniciar.style
        },

        // Cancelado
        'Cancelado': {
            className: icon.cancelado.className,
            style: icon.cancelado.style
        },
        'Canceled': {
            className: icon.cancelado.className,
            style: icon.cancelado.style
        },

        // Em Progresso
        'Em Progresso': {
            className: icon.progresso.className,
            style: icon.progresso.style
        },
        'In Progress': {
            className: icon.progresso.className,
            style: icon.progresso.style
        },

        // Em Execução
        'Em Execução': {
            className: icon.execucao.className,
            style: icon.execucao.style,
        },
        'In Execution': {
            className: icon.execucao.className,
            style: icon.execucao.style,
        },

        // Em Revisão
        'Em Revisão': {
            className: icon.revisao.className,
            style: icon.revisao.style,
        },
        'Under Revision': {
            className: icon.revisao.className,
            style: icon.revisao.style,
        },

        // Concluído
        'Concluído': {
            className: icon.concluido.className,
            style: icon.concluido.style,
        },
        'Completed': {
            className: icon.concluido.className,
            style: icon.concluido.style,
        },
    };

    const timeAgo = (timestamp, lang = localStorage.getItem('lang') || 'pt') => {
        if (!timestamp) return '';

        const translations = {
            en: {
                second: (n) => `${n} second${n !== 1 ? 's' : ''} ago`,
                minute: (n) => `${n} minute${n !== 1 ? 's' : ''} ago`,
                hour: (n) => `${n} hour${n !== 1 ? 's' : ''} ago`,
                day: (n) => `${n} day${n !== 1 ? 's' : ''} ago`,
            },

            pt: {
                second: (n) => `há ${n} segundo${n !== 1 ? 's' : ''}`,
                minute: (n) => `há ${n} minuto${n !== 1 ? 's' : ''}`,
                hour: (n) => `há ${n} hora${n !== 1 ? 's' : ''}`,
                day: (n) => `há ${n} dia${n !== 1 ? 's' : ''}`,
            },

            es: {
                second: (n) => `hace ${n} segundo${n !== 1 ? 's' : ''}`,
                minute: (n) => `hace ${n} minuto${n !== 1 ? 's' : ''}`,
                hour: (n) => `hace ${n} hora${n !== 1 ? 's' : ''}`,
                day: (n) => `hace ${n} día${n !== 1 ? 's' : ''}`,
            },

            fr: {
                second: (n) => `il y a ${n} seconde${n !== 1 ? 's' : ''}`,
                minute: (n) => `il y a ${n} minute${n !== 1 ? 's' : ''}`,
                hour: (n) => `il y a ${n} heure${n !== 1 ? 's' : ''}`,
                day: (n) => `il y a ${n} jour${n !== 1 ? 's' : ''}`,
            },
        };


        const t = translations[lang] || translations['en']; 

        const now = new Date();
        const past = new Date(timestamp);
        const diffMs = now - past;

        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (days > 0) return t.day(days);
        if (hours > 0) return t.hour(hours);
        if (minutes > 0) return t.minute(minutes);
        return t.second(seconds);
    };

    return (
        <header>
            <nav className="navbar top-navbar navbar-light">
                <div className="navbar-header">
                    <div className="navbar-brand">
                        <a href={Hosts.WEB_BACKOFFICE_URI}>
                            <img src={repo_logo_link("logo-mobile.png")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo-mobile img-fluid p-3" />
                            <img src={repo_logo_link("logo.png")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo img-fluid p-2" style={{ marginLeft: '30px' }} />
                        </a>
                    </div>
                </div>

                <div className="navbar-collapse collapse">
                    <ul className="navbar-nav float-left">
                    </ul>
                    <ul className="navbar-nav float-right me-5">
                        <li className="nav-item d-none">
                            <a href={Hosts.backofficeURL} className="nav-link">
                                <span className="ti-search"></span>
                            </a>
                        </li>

                        {
                        dia_hora !== '' ?
                            <li className="nav-item d-flex align-items-center">
                                <div className='d-none d-md-block'>
                                    <p
                                        style={{
                                            border: '1px solid #cccccc',
                                            color: '#606060',
                                            fontFamily: 'monospace',
                                            fontVariantNumeric: 'tabular-nums',
                                            padding: '5px 10px',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        {dia_hora}
                                    </p>
                                </div>
                            </li>
                        :
                            null
                        }

                        <li className="nav-item">
                            <Link
                                className="nav-link"
                                to={{
                                    pathname: '/client_regist',
                                    state: { item: { id: getTokenInfo().id }, operation: 'edit' },
                                }}
                                style={{ display: '' }}
                                replace
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {utilizadorLogado && utilizadorLogado.foto && JSON.parse(utilizadorLogado.foto).length > 0 ? (
                                        <img
                                            src={JSON.parse(utilizadorLogado.foto)[0]?.link}
                                            alt="Foto do utilizador"
                                            className="img-fluid"
                                            style={{
                                                width: '35px',
                                                height: '35px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                marginRight: '10px',
                                            }}
                                        />
                                    ) : (
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                                width: '35px',
                                                height: '35px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ccc',
                                                marginRight: '10px',
                                            }}
                                        >
                                            <i className="bi bi-person" style={{ fontSize: '20px', color: '#fff' }}></i>
                                        </div>
                                    )}
                                    <span>{username}</span>
                                </div>
                            </Link>
                        </li>

                        {
                        content_language.length > 1 ? 
                            <li className="nav-item d-none d-md-block">
                                {
                                content_language.map((cl_el, cl_key) => {
                                    return (
                                        <span key={cl_key}>
                                            <button className={"nav-link text-uppercase " + (lang === cl_el.code ? 'assec-current-lang' : '')} onClick={() => change_lang('' + cl_el.code + '')}>{cl_el.code}</button>
                                            {
                                            parseInt(cl_key) < (parseInt(content_language.length) - 1) ?
                                                <span className='nav-link assec-pr-5 assec-pl-5'>|</span>
                                            :
                                                null
                                            }
                                        </span>
                                    )
                                })
                                }
                            </li>
                        :
                            null
                        }

                        <li className={notifications.length > 0 ? 'nav-item' : 'nav-item d-none'}>
                            <div
                                style={{
                                    position: 'relative',
                                    display: 'inline-block',
                                    marginTop: '25px',
                                }}
                            >
                                <style>
                                    {`
                                        @keyframes fadeInOut {
                                        0% { opacity: 0; transform: translateY(-5px); }
                                        10% { opacity: 1; transform: translateY(0); }
                                        90% { opacity: 1; transform: translateY(0); }
                                        100% { opacity: 0; transform: translateY(-5px); }
                                        }

                                        @keyframes pulse {
                                        0%, 100% { transform: scale(1); }
                                        50% { transform: scale(1.15); }
                                        }

                                        @keyframes softGlow {
                                        0%, 100% {
                                            box-shadow: 0 0 6px rgba(220, 53, 69, 0.5);
                                        }
                                        50% {
                                            box-shadow: 0 0 12px rgba(220, 53, 69, 0.8);
                                        }
                                        }

                                        .dropdown-item:hover {
                                        background-color: #f8f9fa;
                                        }

                                        .notification-badge {
                                        animation: fadeInOut 3s ease-in-out;
                                        box-shadow: 0 0 5px rgba(220, 53, 69, 0.6);
                                        }

                                        .notification-badge.soft-glow {
                                        animation: softGlow 3s ease-in-out infinite;
                                        color: white;
                                        font-weight: 600;
                                        }
                                    `}
                                </style>

                                <button
                                    type="button"
                                    className="btn position-relative"
                                    id="dropdownMenuNotifications"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ border: 'none', background: 'none' }}
                                >
                                    <i
                                        className={icon.bell.className}
                                        style={{
                                            ...icon.bell.style,
                                            animation: 'pulse 2s infinite',
                                        }}
                                    />

                                    <span
                                        className={
                                            `position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notification-badge ${notifications.length > 0 ? 'soft-glow' : 'd-none'
                                            }`
                                        }
                                    >
                                        {notifications.length}
                                    </span>

                                </button>

                                <ul
                                    className="dropdown-menu dropdown-menu-end position-absolute"
                                    aria-labelledby="dropdownMenuNotifications"
                                >
                                    <li>
                                        <p
                                            className="dropdown-item text-truncate border-bottom p-4"
                                            style={{ lineHeight: 0, maxWidth: '300px', minWidth: '250px' }}
                                        >
                                            <strong>{language[lang].notifications}</strong>
                                        </p>
                                    </li>

                                    {notifications.length > 0 ? (
                                        <>
                                            <ul style={{ maxHeight: '320px', overflowY: 'auto', padding: 0, margin: 0 }}>
                                                {notifications.slice(0, 10).map((item, idx) => {
                                                    const currentStatus = lang === 'en' ? item?.state_object?.labelEn : item?.state_object?.labelPt;
                                                    const statusIcon = statusIcons[currentStatus] || {
                                                        className: 'bi bi-question-circle',
                                                        style: { fontSize: '1.5rem', color: '#999' }
                                                    };

                                                    return (
                                                        <li key={idx}>
                                                            <Link
                                                                to={{ pathname: `/${item.type}_view`, state: { item: { id: item.id }, operation: 'view' } }}
                                                                onClick={() => notification_read(item.id_notification)}
                                                                className="dropdown-item p-3"
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <div style={{ marginRight: '12px' }}>
                                                                        <i className={statusIcon.className} style={statusIcon.style}></i>
                                                                    </div>
                                                                    <div style={{ flex: 1 }}>
                                                                        <div className="fw-bold mb-1 text-truncate">
                                                                            {item.type === 'tarefa' && (
                                                                                <span className="badge bg-primary me-1">
                                                                                    {language[lang].task}
                                                                                </span>
                                                                            )}{' '}
                                                                            {item.title}
                                                                        </div>
                                                                        <div className="small text-muted mb-1 text-truncate">
                                                                            {item.description.replace(/^<p>|<\/p>$/g, '')}
                                                                        </div>
                                                                        <div className="text-muted small mt-1">{currentStatus}</div>
                                                                        <div className="text-muted small mt-1">{timeAgo(item.timestamp)}</div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            <div className="text-center border-top pt-2">
                                                <button
                                                    onClick={notification_read_all}
                                                    className="btn p-1 text-primary"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        fontSize: '0.9rem',
                                                        borderRadius: '0.5rem',
                                                    }}
                                                    onMouseOver={e => e.currentTarget.style.backgroundColor = color.corSecundaria.rgb}
                                                    onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    {language[lang].see_all_notifications}
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <li>
                                            <p className="dropdown-item text-center text-muted p-4 m-0">
                                                {language[lang].notifications_empty}
                                            </p>
                                        </li>
                                    )}

                                </ul>
                            </div>
                        </li>

                        {/* 
                        <li className="nav-item" style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                            <Notificacoes tarefas={tarefasUtilizador} entidadeLogada={entidade} />

                        </li>
                        */}

                        <li className="nav-item">
                            <a href={Hosts.WEB_BACKOFFICE_URI} onClick={logout} className="nav-link">
                                <img alt='' src={repo_icons_link("sair.svg")} />
                                <span>{language[lang].logout}</span>
                            </a>
                        </li>

                        <li className="nav-item d-none">
                            <a href={Hosts.WEB_SITE_URI} target="_blank" rel="noreferrer" className="nav-link">
                                <img alt='' src={repo_icons_link("website.svg")} />
                                <span>{language[lang].web_page}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
}

export default Header;